import React from 'react';
import ReactDOM from 'react-dom';
import SMRoomExceptionResource from 'resources/SMRoomExceptionResource';
import SMConst from 'lib/SMConst';
import SMORoomExceptionCalendarBaloon from 'components/dashboard/calendar/SMORoomExceptionCalendarBaloon';
import SMRoomExceptionHelper from 'components/helpers/SMRoomExceptionHelper';

class SMORoomExceptionListView extends React.Component {
  
  shouldExceptionRender(exception) {
    if (this.props.plan.has_session_price) {
      if (exception.has_session_change_price) {
        if ((this.props.selectedCalendar == SMConst.CalendarType.HourlyPrice && this.props.plan.min_required_session_hour_unit == SMConst.RequiredUnit.Hour) ||
            (this.props.selectedCalendar == SMConst.CalendarType.DailyPrice && this.props.plan.min_required_session_hour_unit == SMConst.RequiredUnit.Day)) {
          return true;
        }
      }
    } else {
      if (!exception.has_session_change_price) {
        if ((this.props.selectedCalendar == SMConst.CalendarType.DailyPrice && exception.has_daily_change_price) ||
            (this.props.selectedCalendar == SMConst.CalendarType.HourlyPrice && exception.has_hourly_change_price)) {
          return true;
        }
      }
    }
    
    return false;
  }
  
  itemDidClick(item, e) {
    e.preventDefault();
    e.persist();
    const baloon = <SMORoomExceptionCalendarBaloon
      selectedCalendar={this.props.selectedCalendar}
      item={item}
      clientX={e.clientX}
      clientY={e.clientY}
      room={this.props.room}
      plan={this.props.plan}
      delegate={this.props.delegate} />;
    
    ReactDOM.render(baloon, document.getElementById('js-baloon-container'));
  }

  deleteItemDidClick(itemId, e) {
    e.preventDefault();
    e.persist();
    const responseHandler = (data, error, xhr)=>{
      if (xhr.status == 204) {
        this.props.delegate.formDidUpdate(e);
      }
    };
        
    SMRoomExceptionResource.deleteException(itemId, {room_id: this.props.room.id}, responseHandler);
  }
  
  render() {
    if (!this.props.plan.exceptions) return null;  
    let rows = [];
    for (let i=0; i < this.props.plan.exceptions.length; i++) {
      const exception = this.props.plan.exceptions[i];
      if (this.shouldExceptionRender(exception)) {
        let displayStartWeekDays = '', 
            hours,
            endedAt = new Date(exception.ended_at),
            startDay = I18n.l('date.ymd', exception.started_at),
            endDay = I18n.l('date.ymd', endedAt.setDate(endedAt.getDate())),
            startWeekDays = exception.start_weekday.split(',');
            
        if (exception.frequency == SMConst.Frequency.Weekly) {
          if (startWeekDays != '' && startWeekDays.length < 7) {
            for (var j=0; j < startWeekDays.length; j++) {
              if (displayStartWeekDays.length > 0) {
                displayStartWeekDays += '・';
              }
              displayStartWeekDays += I18n.t('date.abbr_day_names')[parseInt(startWeekDays[j])];
            }
          }
          if (exception.is_holiday) {
            displayStartWeekDays += '祝日';
          }
        } else if (exception.frequency == SMConst.Frequency.Daily) {
          displayStartWeekDays += '毎日';
        }
        
        if (exception.is_all_day) {
          hours = '終日';
        } else {
          hours = exception.start_hour + ':00 〜 ' + exception.end_hour + ':00';
        }
        
        rows.push(
          <div key={exception.id} className={'special-price-list__box' + (exception.status ? '' : ' special-price-list__disable')}>
            <a href="#" onClick={this.itemDidClick.bind(this, exception)} className="w450 dib">
              {startDay} 〜 {endDay} / {displayStartWeekDays} / {hours}
            </a>
            特別価格 {SMRoomExceptionHelper.priceText(exception, this.props.plan, this.props.selectedCalendar)}
            <a href="#" onClick={this.deleteItemDidClick.bind(this, exception.id)} className="fr"><i className="fa fa-times"></i> 削除</a>
          </div>
        );
      }
    }
    
    return <div className="special-price-list">{rows}</div>;
  }
}

export default SMORoomExceptionListView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomExceptionListView.jsx